import { useTheme } from 'styled-components';

import { MessageOptions, MessageType } from '@dreryk/react-components';

export const useOptions = (): MessageOptions<{ [MessageType.POSITIVE]: MessageType }> => {
   const theme = useTheme();
   return {
      [MessageType.POSITIVE]: {
         color: theme.success,
         backgroundColor: theme.successLighter,
         labelColor: theme.successDark,
      },
   };
};
